module.exports = __webpack_public_path__ + "img/01.365f4d6c.png";